module.exports = __webpack_public_path__ + "static/media/nucleo-icons.f82ec6ba.ttf";